import { useQuery } from 'react-query'

import { SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { secondaryCategoryQueryConfig } from '@webapp/platform/organization-management/query-configs/secondaryCategory'

// Reuses the existing core SecondaryCategoryRepository.getById via the
// owning domain's query config (ADR-6; deprecated core entity location
// kept per ADR-8 deferred cleanup). `enabled` lets the config-driven
// detail FS call all three header hooks unconditionally (rules-of-hooks).
export const useQuerySecondaryCategoryDetailHeader = (
  secondaryCategoryId: number,
  enabled = true
) => {
  const { data, isFetching } = useQuery({
    ...secondaryCategoryQueryConfig.getById(secondaryCategoryId),
    enabled,
  })

  return {
    secondaryCategory: data?.data ? new SecondaryCategory(data.data) : null,
    isLoading: isFetching,
  }
}
